/* eslint-disable max-lines */
import { FC } from "react"
import { Translate } from "../../../../../constant/Translate"
import { Card } from "../../../../../_webui/layout/components/Card"
import { Layout } from "../../../../../_webui/layout/components/Layout"
import { Table } from "../../../../../_webui/layout/components/Table"
import { TotalRecords } from "../../../../../_webui/layout/components/Typography/TotalRecords"
import { SchedulesButtonGroup } from "../../components/list/ButtonGroup"
import { SchedulesFormSearch } from "../../components/list/FormSearch"
import { SchedulesModalConfirm } from "../../components/list/ModalConfirm"
import { SchedulesListDataType } from "../../models/list"
import { useSchedulesList } from "./modules/useList"
import { Styled } from "./styled"

const { StyledOverRecord } = Styled
const { TEXT_T190 } = Translate

export const SchedulesList: FC = () => {
  const {
    arrivalCities,
    breadcrumbItems,
    columns,
    countries,
    dataSource,
    departments,
    disabledDateTo,
    dispatchType,
    dispatchTypeDetail,
    form,
    fullName,
    goBack,
    goToAttention,
    goToSafety,
    goToSchedulesAdd,
    goToSchedulesConfirmDelete,
    goToSchedulesDetail,
    goToSchedulesEdit,
    handleCancelModalExport,
    handleExportFile,
    handleOpenModalExport,
    handleSearch,
    isDisabledArrivalCity,
    isDisabledBtnCreateOrSend,
    isDisabledBtnDelete,
    isDisabledBtnRefer,
    isDisabledDispatchTypeDetail,
    isFromSCR114UserSearch,
    isHiddenBtnCreateOrSendAttentions,
    isHiddenBtnCreateOrSendSafeties,
    isHiddenBtnDelete,
    isHiddenBtnEdit,
    isHiddenBtnExportCsv,
    isHiddenBtnExportExcel,
    isHiddenBtnExportExcelSafeties,
    isHiddenBtnExportExcelTravelers,
    isHiddenBtnRefer,
    isHiddenBtnResetForm,
    isHiddenBtnSearchBasic,
    isLoading,
    isLoadingLayout,
    isOpenExportFrm103OverRecord,
    isOpenLoadData,
    isOpenModalExport,
    isOpenShowData,
    isPathnameSchedules,
    isPathnameSchedulesOrTravelers,
    isPathnameTravelers,
    isResetTable,
    messageConfirmDownload,
    onBlurBasic,
    onCancelCustomLoadData,
    onCancelExportFrm103OverRecord,
    onChange,
    onChangeArrivalCity,
    onChangeArrivalCountryCode,
    onChangeDispatchType,
    onChangeTable,
    onClickReset,
    onKeyDownBasic,
    onOkExportFrm103OverRecord,
    onOkLoadData,
    onOkShowData,
    overRecordLabel,
    perItem,
    purposeTravel,
    rowSelection,
  } = useSchedulesList()

  return (
    <Layout
      breadcrumbItems={breadcrumbItems}
      isLoadingLayout={isLoadingLayout}
      title={TEXT_T190}
    >
      <Card heading={TEXT_T190} isLoading={isLoading}>
        {!isFromSCR114UserSearch && (
          <SchedulesFormSearch
            arrivalCities={arrivalCities}
            countries={countries}
            departments={departments}
            disabledDateTo={disabledDateTo}
            dispatchType={dispatchType}
            dispatchTypeDetail={dispatchTypeDetail}
            form={form}
            fullName={fullName}
            handleSearch={handleSearch}
            isDisabledArrivalCity={isDisabledArrivalCity}
            isDisabledDispatchTypeDetail={isDisabledDispatchTypeDetail}
            isHiddenBtnResetForm={isHiddenBtnResetForm}
            isHiddenBtnSearchBasic={isHiddenBtnSearchBasic}
            isPathnameSchedules={isPathnameSchedules}
            onBlurBasic={onBlurBasic}
            onChangeArrivalCity={onChangeArrivalCity}
            onChangeArrivalCountryCode={onChangeArrivalCountryCode}
            onChangeDispatchType={onChangeDispatchType}
            onClickReset={onClickReset}
            onKeyDownBasic={onKeyDownBasic}
            purposeTravel={purposeTravel}
          />
        )}
        <TotalRecords
          perItem={perItem}
          titleLeft={TEXT_T190}
          titleRight={<StyledOverRecord>{overRecordLabel}</StyledOverRecord>}
          total={dataSource?.length}
        />
        <Table
          columns={columns}
          dataSource={dataSource}
          isResetTable={isResetTable}
          onChange={onChange}
          onChangeTable={onChangeTable}
          rowKey={(record: SchedulesListDataType) =>
            record.info.travelScheduleId
          }
          rowSelection={rowSelection}
        />
        <SchedulesButtonGroup
          goBack={goBack}
          goToAttention={goToAttention}
          goToSafety={goToSafety}
          goToSchedulesAdd={goToSchedulesAdd}
          goToSchedulesConfirmDelete={goToSchedulesConfirmDelete}
          goToSchedulesDetail={goToSchedulesDetail}
          goToSchedulesEdit={goToSchedulesEdit}
          handleOpenModalExport={handleOpenModalExport}
          isDisabledBtnCreateOrSend={isDisabledBtnCreateOrSend}
          isDisabledBtnDelete={isDisabledBtnDelete}
          isDisabledBtnRefer={isDisabledBtnRefer}
          isFromSCR114UserSearch={isFromSCR114UserSearch}
          isHiddenBtnCreateOrSendAttentions={isHiddenBtnCreateOrSendAttentions}
          isHiddenBtnCreateOrSendSafeties={isHiddenBtnCreateOrSendSafeties}
          isHiddenBtnDelete={isHiddenBtnDelete}
          isHiddenBtnEdit={isHiddenBtnEdit}
          isHiddenBtnExportCsv={isHiddenBtnExportCsv}
          isHiddenBtnExportExcel={isHiddenBtnExportExcel}
          isHiddenBtnExportExcelSafeties={isHiddenBtnExportExcelSafeties}
          isHiddenBtnExportExcelTravelers={isHiddenBtnExportExcelTravelers}
          isHiddenBtnRefer={isHiddenBtnRefer}
          isPathnameTravelers={isPathnameTravelers}
          isPathnameSchedulesOrTravelers={isPathnameSchedulesOrTravelers}
        />
        <SchedulesModalConfirm
          isOpen={isOpenModalExport}
          isOpenExportFrm103OverRecord={isOpenExportFrm103OverRecord}
          isOpenLoadData={isOpenLoadData}
          isOpenShowData={isOpenShowData}
          messageConfirmDownload={messageConfirmDownload}
          onCancel={handleCancelModalExport}
          onCancelCustomLoadData={onCancelCustomLoadData}
          onCancelExportFrm103OverRecord={onCancelExportFrm103OverRecord}
          onOk={handleExportFile}
          onOkExportFrm103OverRecord={onOkExportFrm103OverRecord}
          onOkLoadData={onOkLoadData}
          onOkShowData={onOkShowData}
        />
      </Card>
    </Layout>
  )
}
